<template>
    <div :class="['player', active_player ? 'active shadow-active' : 'shadow-inactive']">
         <div class="round-end" v-if="gm.roundFinished && active_player">
             <div class="round-end-text">{{__('games.round_end_remove_darts')}}</div>
        </div>
        <div class="winner" v-if="winner && winner == player_name">{{__('games.winner')}}</div>
        <div class="loser" v-if="winner && winner != player_name">&nbsp;</div>
        <div :class="['name', showCPUBar ? 'cpu' : '']"><i class="fas fa-circle" v-if="checkStartingPlayer()"></i> {{player_name}}</div>
        <div class="numbers">
            <div class="setslegs">
                <div class="sets">
                    <div class="label">{{__('games.sets')}}</div>
                    <div class="won">{{sets_player}}</div>
                    <div class="towin">{{gm.gameInstance.game.sets}}</div>
                </div>
                <div class="legs">
                    <div class="label">{{__('games.legs')}}</div>
                    <div class="won">{{legs_player}}</div>
                    <div class="towin">{{gm.gameInstance.game.legs}}</div>
                </div>
            </div>
            <div class="scores">
                <div :class="['score', deactivate_smallscore ? 'text-center' : '']">{{calculated_score ? calculated_score : score_player}}</div>
                <div class="lastscore" v-if="!deactivate_smallscore">{{score_player}}</div>
                <div class="throw">
                    <div  v-if="singlescores.length != 0 || throw_player == 0" :class="['throw1',colorCheck(singlescores[0])]">{{singlescores[0] ? singlescores[0].str : ''}}</div>
                    <div  v-if="singlescores.length != 0 || throw_player == 0" :class="['throw2',colorCheck(singlescores[1])]">{{singlescores[1] ? singlescores[1].str : ''}}</div>
                    <div  v-if="singlescores.length != 0 || throw_player == 0" :class="['throw3',colorCheck(singlescores[2])]">{{singlescores[2] ? singlescores[2].str : ''}}</div>
                    <div :class="['fullscore sum', singlescores.length != 0 || throw_player == 0 ? 'inverted' : '']">{{throw_player}}</div>
                </div>
            </div>
            <game-asset-statistics-small :content="content ? content : gm.gameInstance.content" :players="gm.players" :player_id="player_id"></game-asset-statistics-small>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'player_name',
            'player_id',
            'active_player',
            'score_player',
            'sets_player',
            'legs_player',
            'throw_player',
            'singlescore_player',
            'calculated_score',
            'container_width',
            'deactivate_sum',
            'deactivate_smallscore',
            'startplayer',
            'content',
            'gm',
            'winner',
            'cputimer'
        ],
        data() {
            return {
                scoreContainerWidth: 6,
                singlescores: JSON.parse(this.singlescore_player),
                showCPUBar: false
            }
        },
        watch: {
            singlescore_player: function(newVal, oldVal) {
                this.singlescores = JSON.parse(this.singlescore_player)
            },
            player_id: function() {
                //check if new entry is cpu
                this.cputimerCheck();
            }
        },
        mounted() {
            if (this.container_width) this.scoreContainerWidth = this.container_width;
            if (this.cputimer) {
                this.showCPUBar = true;
                //player box is a cpu box, use gradient loading bar
                document.documentElement.style.setProperty('--cputimer', this.cputimer + 's');
            }
        },
        methods: {
            singlescore_sum() {
                var returnValue = 0;
                this.singlescores.forEach(score => {
                    if (!score.missed)
                        returnValue += score.value;
                });
                return returnValue;
            },
            colorCheck(number) {
                if (number !== undefined && number.success) return "success";
                if (number !== undefined && number.missed) return "miss";
                if (number === undefined) return "open";
            },
            checkStartingPlayer() {
                if (this.startplayer) {
                    return this.startplayer == this.player_id
                } else {
                    return this.gm.startingPlayerId == this.player_id
                }
            },
            cputimerCheck() {
                this.showCPUBar = false;
                setTimeout(() => {
                    if (this.cputimer) {
                        this.showCPUBar = true;
                    }
                }, 0);
            }
        }
    }
</script>


<style scoped>

</style>

